$(function ()
{
	if (typeof FroalaEditor == "undefined") {
		return;
	}
	(function (global, factory)
	{
		typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('froala-editor')) :
			typeof define === 'function' && define.amd ? define(['froala-editor'], factory) :
				(factory(global.FroalaEditor));
	}(window, (function (FE)
	{
		'use strict';
		FE = FE && FE.hasOwnProperty('default') ? FE['default'] : FE;

		FE.PLUGINS.upload_errors = function (editor)
		{
			/** @type {JQuery} $ */
			var $ = editor.$;

			function _init()
			{
				editor.events.on('imageManager.imageLoaded', function (/** @type {JQuery} */ $img)
				{
					$img.parents('.fr-image-container').find('.fr-delete-img').hide();
				});
				editor.events.on('image.error', _onImageError);
				editor.events.on('file.error', _onFileError);
			}

			function _onFileError(error, response)
			{
				const frShowErrorMessage = function (message)
				{
					editor.image.showProgressBar();
					var $popup = editor.popups.get('image.insert');
					var $layer = $popup.find('.fr-image-progress-bar-layer');
					$layer.addClass('fr-error');
					var $message_header = $layer.find('h3');
					$message_header.text(message);
					editor.events.disableBlur();
					$message_header.focus();
				}

				frShowErrorMessage(response ?? error.message);
			}

			function _onImageError(error, response)
			{
				
				const frShowErrorMessage = function (message)
				{
					editor.image.showProgressBar();
					var $popup = editor.popups.get('image.insert');
					var $layer = $popup.find('.fr-image-progress-bar-layer');
					$layer.addClass('fr-error');
					var $message_header = $layer.find('h3');
					$message_header.text(message);
					editor.events.disableBlur();
					$message_header.focus();
				}

				frShowErrorMessage(response ?? error.message);
			}

			return {
				_init: _init,
			}
		}
	})));
});